import React, { useEffect, useState } from "react";
import "./about.css";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../Config/Firebase/config";
import { toast } from "react-toastify";
import aboutIconData from "./iconData";
const About = () => {
    const location = <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1.1" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8.063c-1.691 0-3.063-1.371-3.063-3.063s1.371-3.063 3.063-3.063 3.063 1.371 3.063 3.063-1.371 3.063-3.063 3.063zM6.063 5c0-1.070 0.867-1.938 1.938-1.938s1.938 0.867 1.938 1.938c0 1.070-0.867 1.938-1.938 1.938s-1.938-0.867-1.938-1.938z"></path></svg>;
    const [achievementData,setAchievementData] = useState([]);
    const [experienceData, setExperienceData] = useState([]);

    useEffect(() => {
        const CACHE_KEY = "aboutCache";
        const CACHE_EXPIRATION = 7 * 24 * 60 * 60 * 1000; //1 week
        const fetchAboutData = async() => {
            const achievementCollectionRef = collection(db, "achivements");
            const experienceCollectionRef = collection(db, "experiences");
            try{
                const achData = await getDocs(achievementCollectionRef);
                const achFilteredData = achData.docs.map((doc) => ({
                    ...doc.data(),
                    id: doc.id,
                }))
                const expData = await getDocs(experienceCollectionRef);
                const expFilteredData = expData.docs.map((doc) => ({
                    ...doc.data(),
                    id: doc.id,
                }))
                setAchievementData(achFilteredData);
                setExperienceData(expFilteredData);

                const currentTime = new Date().getTime();
                const cachedData = {
                    data: { achievementData: achFilteredData, experienceData: expFilteredData },
                    timestamp: currentTime,
                };
                localStorage.setItem(CACHE_KEY, JSON.stringify(cachedData));
            }catch(error){
                toast.error("Could not Load About Data");
            }
        }
        
        const cachedData = localStorage.getItem(CACHE_KEY);

        if (cachedData) {
            const { data, timestamp } = JSON.parse(cachedData);
            const currentTime = new Date().getTime();
            if (currentTime - timestamp <= CACHE_EXPIRATION) {
                setAchievementData(data.achievementData);
                setExperienceData(data.experienceData);
            } else {
                fetchAboutData();
            }
        } else {
            fetchAboutData();
        }
    }, []);
    return (
        <section className="about section" id="about">
            <div className="container">
                <div className="row">
                    <div className="section-title padd-15">
                        <h2>About</h2>
                    </div>
                </div>
                <h3 className="title">Achievements</h3>
                <div className="achievement-content padd-15">
                    <div className="row">
                        {
                            achievementData.map((data) => (
                            <div className="achievement-item padd-15" key={data.id}>
                                <div className="achievement-item-inner">
                                    <div className="icon">
                                    <i className="fa">{aboutIconData[data.icon]}</i>
                                    </div>
                                    <h2>{data.target}</h2>
                                    <h4>{data.title}</h4>
                                </div>
                            </div>
                        ))
                        }
                    </div>
                </div>
                
                <div className="experience-content">
                    <h3 className="title">Worked With</h3>
                    <div className="row">
                        {experienceData.map((data) => (
                            <div className="experience-item padd-15" key={data.id}>
                                <div className="experience-item-inner">
                                    <h3 className="timeline-title">{data.title}</h3>
                                    <h4 className="timeline-date">        
                                        <i className="fa">{location}</i>
                                        <span>{data.address}</span>
                                    </h4>
                                    <p className="timeline-text">{data.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
